import React from 'react';
import { ITaskEditFormDisplayProps } from './TaskEditForm';
import { IEditField } from './formTools';
import { EditDate, EditDateField } from './EditDate';

export const DueDateDisplay: React.FC<ITaskEditFormDisplayProps> = ({ task, setIsEditing }) => (
  <EditDate task={task} setIsEditing={setIsEditing} fieldName="dueDate" />
);

export const EditDueDateField: React.FC<IEditField> = ({ submitOnChange, cancel }) => (
  <EditDateField submitOnChange={submitOnChange} fieldName="dueDate" cancel={cancel} />
);
